define('core/modules/hoverbox',['jquery', 'core/global/helpers', 'core/modules/panelizr', 'core/ef_plugins/disruptr', 'libs/amplify.core'], function ($, helpers, p) {
    return {
        init: function(isPricingFlag, disruptrOptionsObj) {
            var $body = $('body'),
                plugin,
                isPricing = helpers.toBool(isPricingFlag),
                panelizr,
                panelizrs,
                pricingMap,
                isPricedTour;

            console.log('hoverbox');

            // Disable if 1. pricing section exist but insert with nonpricing hoverbox
            //                2. pricing section not exist but insert with pricing hoverbox
            window.EFTOURS = window.EFTOURS || {};
            window.EFTOURS.globalState = window.EFTOURS.globalState || {};

            isPricedTour = (window.EFTOURS.globalState.isPricedTour == true);
            if (isPricedTour != isPricing) return true;

            // run panelizr
            p.init();

            // create disruptr and save reference to plugin obj
            plugin = $body.disruptr(disruptrOptionsObj).data('plugin_disruptr');

            // stop timer when user interacts with pricing fields
            $body.on('focus', 'input', function() {
                if (plugin != undefined && plugin.timer != undefined) plugin.timer.stop();
            });

            // start timer on blur with pricing fields
            $body.on('blur', 'input', function () {
                // If already submit, destroy plugin
                if (plugin.hasSubmittedFormOrLogin()) {
                    plugin.destroy();
                    return;
                }

                // Get brand new panelizr data from gateway change
                panelizrs = [];
                $(".panelizr-link").each(function () {
                    if ($(this).data('plugin_panelizr')) {
                        panelizrs.push($(this).data('plugin_panelizr'));
                    }
                });
                // If One of the panelizr is already running, stop the timer
                for (var i = 0; i < panelizrs.length; i++) {
                    if (panelizrs[i].isOpen && plugin != undefined) {
                        plugin.timer.stop();
                        return;
                    }
                }

                // Passing true indicates that the timer should only start if it has previously been started.
                if (!$(document.activeElement).is("input")) {
                    plugin.timer.start(true);
                }
            });

            // pub/sub events for start/stop of timer
            amplify.subscribe("mediaframework/playing", function () { plugin.timer.stop(); });
            amplify.subscribe("mediaframework/paused", function () { plugin.timer.start(true); });
            amplify.subscribe("mediaframework/played", function () { plugin.timer.start(true); });

            // Pricing Hoverbox
            if (isPricing) {
                panelizr = $('#disruptr-panelizr').data('plugin_panelizr');

                // Map the price field keys to the keys that Liveball expects
                pricingMap = {
                    'departMonth': 'travelMonth',
                    'departYear': 'travelYear',
                    'departCity': 'departureCity',
                    'departGate': 'departureGateway'
                };

                amplify.subscribe("price/load", function (data) {
                    panelizr.options.urlData = helpers.mapKeys(data, pricingMap);
                });

                var startDisruptivePricing = _.once(function () {
                    if (plugin == undefined || plugin.timer == undefined) return;
                    plugin.timer.start();
                    amplify.subscribe("modal/open", function () { plugin.timer.stop(); });
                    amplify.subscribe("modal/close", function () { plugin.timer.start(true); });
                });

                amplify.subscribe("price/quote", function (data) {
                    panelizr.options.urlData = helpers.mapKeys(data, pricingMap);
                    startDisruptivePricing();
                });
            } else {
                // If there is nopricing section on the page, trigger timer immediately.
                var startDisruptiveNonPricing = _.once(function () {
                    if (plugin == undefined || plugin.timer == undefined) return;
                    plugin.timer.start();
                    amplify.subscribe("modal/open", function () { plugin.timer.stop(); });
                    amplify.subscribe("modal/close", function () { plugin.timer.start(true); });
                });
                startDisruptiveNonPricing();
            }

            return plugin;
        }
    } 
});
